export enum PAYMENT_METHODS_ENUM {
  CREDCARD = 1,
  BILLET = 2,
  PIX = 3,
}
